// extracted by mini-css-extract-plugin
export default {"image":"rX-z","loaded":"sX-z"};